import React from 'react';

export default (value, entry) => {
    const { color } = entry;
    return <span style={{ color, textTransform:'capitalize' }}>{value}</span>;
};